/**
 * @author
 * @description 题库管理模块
 */
import {
  getQuestionList,
  getQuestionClassify,
  getAddQuestionClassify,
  getAddQuestion,
  getDelQuestionClassify,
  getEditQuestionClassify,
  getImportQuestionClassify,
  getEidtQuestion,
  batchAudit,
  getDelQuestion,
  getImportQuestion,
  getQuestionDetail,
  generalUpload,
  downloadQuestion,
} from "@/api/questionBank";

const state = () => ({
  // 题库分类数据
  questionClassify: [],
  // 题库列表数据
  questionBankList: [],
  newAddQuestion: {},
});
const getters = {};
// 同步方法写在这里--对应commit
const mutations = {
  setQuestionClassify(state, data) {
    state.questionClassify = data;
  },
  setQuestionList(state, data) {
    state.questionBankList = data;
  },
  setNewAddQuestion(state, data) {
    state.newAddQuestion = data;
  },
};

// 异步请求写在这里--对应dispatch
const actions = {
  getQuestionClassify({}, data) {
    return new Promise((resolve, reject) => {
      getQuestionClassify(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getQuestionList({}, data) {
    return new Promise((resolve, reject) => {
      getQuestionList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAddQuestionClassify({}, data) {
    return new Promise((resolve, reject) => {
      getAddQuestionClassify(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAddQuestion({}, data) {
    return new Promise((resolve, reject) => {
      getAddQuestion(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDelQuestionClassify({}, data) {
    return new Promise((resolve, reject) => {
      getDelQuestionClassify(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEditQuestionClassify({}, data) {
    return new Promise((resolve, reject) => {
      getEditQuestionClassify(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getImportQuestionClassify({}, data) {
    return new Promise((resolve, reject) => {
      getImportQuestionClassify(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEidtQuestion({}, data) {
    return new Promise((resolve, reject) => {
      getEidtQuestion(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  batchAudit({}, data) {
    return new Promise((resolve, reject) => {
      batchAudit(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDelQuestion({}, data) {
    return new Promise((resolve, reject) => {
      getDelQuestion(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getImportQuestion({}, data) {
    console.log("data-ddd", data);
    // console.log("fileData-ddd", fileData);
    return new Promise((resolve, reject) => {
      getImportQuestion(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取试题详情
  getQuestionDetail({}, data) {
    return new Promise((resolve, reject) => {
      getQuestionDetail(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取试题详情
  generalUpload({}, data) {
    return new Promise((resolve, reject) => {
      generalUpload(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 导出试题
  downloadQuestion({}, data) {
    return new Promise((resolve, reject) => {
      downloadQuestion(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default { state, getters, mutations, actions };
